export default "__VITE_ASSET__mQ$x2FKY__"